import classNames from "classnames";

import { AlertCircle } from "../Icons/general-interface-2";
import { Text } from "../Type";
import styles from "./index.module.scss";

type PropsType = {
  title?: string;
  content?: string;
  bullets?: Array<string>;
  error?: boolean;
  warning?: boolean;
  success?: boolean;
  className?: string;
};

const NotificationBanner = ({
  className,
  title,
  content,
  bullets,
  error,
  warning,
  success,
}: PropsType) => {
  return (
    <div
      className={classNames(className, styles.container, {
        [styles.error]: error,
        [styles.warning]: warning,
        [styles.success]: success,
      })}
    >
      <div className={styles.iconCol}>
        <AlertCircle
          className={classNames(styles.icon, {
            [styles.error]: error,
            [styles.warning]: warning,
            [styles.success]: success,
          })}
        />
      </div>
      <div className={styles.textCol}>
        {title && <Text size="large">{title}</Text>}
        {content && (
          <Text size="small" lineHeight="large">
            {content}
          </Text>
        )}
        {bullets &&
          bullets.map((item, index) => {
            return (
              <Text key={index.toString()} size="small" lineHeight="medium">
                - {item}
              </Text>
            );
          })}
      </div>
    </div>
  );
};

export default NotificationBanner;
